export const distanceComparator = (spotA, spotB) => {
    // treat null distance as 0m
    const distanceA = spotA.distance?.linearMeters || 0;
    const distanceB = spotB.distance?.linearMeters || 0;

    return distanceA - distanceB;
};

export const advertisedPriceComparator = (spotA, spotB) => {
    // if no applicable rate, treat this spot as the highest possible price
    // so it gets sorted at the end
    const priceA =
        spotA.selectedRate?.advertisedPrice?.value || Number.MAX_SAFE_INTEGER;
    const priceB =
        spotB.selectedRate?.advertisedPrice?.value || Number.MAX_SAFE_INTEGER;

    return priceA - priceB;
};
